import { catchError } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { APP_CONFIG } from '@app/shared/models/constants';
import { HttpClient } from '@angular/common/http';
import { ActiveBookingDates } from '@app/account/models/active-booking-dates';
import { EscortVacation } from '@app/account/models/escort-vacation';
import { UpdateVacation } from '@app/account/models/update-vacation';

@Injectable({
  providedIn: 'root',
})
export class VacationService {
  private readonly config = inject(APP_CONFIG);
  private readonly http = inject(HttpClient);

  getActiveBookingDates(): Observable<ActiveBookingDates> {
    return this.http
      .get<ActiveBookingDates>(
        `${this.config.apiV3}/user/account/booking-dates`
      )
      .pipe(catchError(() => of(null)));
  }

  getVacations(): Observable<EscortVacation[]> {
    return this.http.get<EscortVacation[]>(
      `${this.config.apiV3}/user/account/vacations`,
      {}
    );
  }

  addVacation(vacation: EscortVacation): Observable<UpdateVacation> {
    return this.http.post<UpdateVacation>(
      `${this.config.apiV3}/user/account/vacation`,
      vacation
    );
  }

  editVacation(vacation: EscortVacation): Observable<UpdateVacation> {
    return this.http.put<UpdateVacation>(
      `${this.config.apiV3}/user/account/vacation`,
      vacation
    );
  }

  removeVacation(vacationId: number): Observable<boolean> {
    return this.http.delete<boolean>(
      `${this.config.apiV3}/user/account/vacation/${vacationId}`
    );
  }
}
